/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
import axios from "axios";

export const fetchExperience = (baseUrl, UUID) =>
  axios.get(
    `${baseUrl}/product_demos/${UUID}/localized_demo`
  );

export const fetchExperienceMock = (baseUrl, UUID) =>
  axios.get("./mockResponse.json", {
    params: {
      baseUrl,
      UUID,
    },
  });

export default fetchExperience;
